export default "__VITE_ASSET__D8UAd3F3__"